import { useDispatch, useSelector } from "react-redux";
import MainNavbar from "../../components/Navbars/MainNavbar";
import TranslationWrapper from "../../components/TranslationWrapper/TranslationWrapper";
import React from "react";
import UpsellTable from "./UpsellTable";
import { DialogProvider } from "./modernTS/JUI/Dialogs";
import { SalesareaProvider, useSalesareaCtx } from "./modernTS/salesarea/SalesareaContext";
import { Box, Button } from "@mui/material";
import { Alert } from "@mui/lab";
import * as actions from "../../store/actions";

function Inner() {
  const salesarea = useSalesareaCtx();
  const dispatch = useDispatch();
  const hasMenuSalesarea = salesarea.id !== salesarea.menuSalesareaId;

  if (hasMenuSalesarea) {
    return (
      <Box>
        <Alert severity={"info"} variant={"standard"}>
          This salesarea has a menu salesarea. If you want to configure upsells for this salesarea, you should do that
          in the menu salesarea.
          <Box>
            <Button
              color={"info"}
              onClick={() => {
                dispatch({
                  type: actions.SET_FILTER,
                  payload: {
                    key: "vestiging_id",
                    filter: {
                      field: "vestiging_id",
                      operator: "=",
                      value: salesarea.menuSalesareaId,
                      label: salesarea.naam,
                    },
                  },
                });
              }}
              sx={{ mt: 1 }}
              variant={"contained"}
            >
              Switch to menu salesarea
            </Button>
          </Box>
        </Alert>
      </Box>
    );
  }
  return <UpsellTable />;
}

export default function UpsellPage(props: { vestiging_id: null | number; appTarget: string }) {
  const salesareaId = useSelector((state) => state.filtersV2?.vestiging_id?.value);

  return (
    <SalesareaProvider salesareaId={salesareaId}>
      <DialogProvider>
        <MainNavbar paginaTitel={<TranslationWrapper tDefault={"Upsell"} tKey={"upsell.table.title"} />} />
        <Inner />
        {/*<Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 2, mb: 2 }}>*/}
        {/*  <Card>*/}
        {/*    <CardHeader*/}
        {/*      title="One-time upsell"*/}
        {/*      subheader="Shown just once per customer visit, useful for promotions or for highlighting high-margin products"*/}
        {/*    />*/}
        {/*    <CardContent>WIP</CardContent>*/}
        {/*  </Card>*/}
        {/*  <Card>*/}
        {/*    <CardHeader*/}
        {/*      title="No-drink upsell"*/}
        {/*      subheader="Shown when a customer is about to place an order without a drink in their cart"*/}
        {/*    />*/}
        {/*    <CardContent>WIP</CardContent>*/}
        {/*  </Card>*/}
        {/*  <Card>*/}
        {/*    <CardHeader*/}
        {/*      title="No-food upsell"*/}
        {/*      subheader="Shown when a customer is about to place an order without any food in their cart"*/}
        {/*    />*/}
        {/*    <CardContent>WIP</CardContent>*/}
        {/*  </Card>*/}
        {/*</Box>*/}
      </DialogProvider>
    </SalesareaProvider>
  );
}
